import { Box } from "@mui/material";
import styled from "styled-components";

export const ImgWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: ${(props) => props.width ? props.width : 'auto'};
  height:${(props) => props.height ? props.height : 'auto'};
  overflow: hidden;
`;
////////////////////////////////////////

export const StyledImg = styled.img`
  display: ${(props) => (props.isShown ? "block" : "none")};
  object-fit: ${props => props.objectFit ?? ''};
`;